import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import "./font-awesome";
import "./fonts/Gilroy/Gilroy-ExtraBold.ttf";
import "./fonts/Gilroy/Gilroy-Light.ttf";
import "./fonts/Lato/Lato-Regular.ttf";
import "./fonts/ProximaNova-Regular.ttf";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import store from "./store/index";

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
